import clsx from "clsx";
import type { HTMLAttributes, ReactNode } from "react";

export type StickerColor =
  | "green"
  | "pink"
  | "orange"
  | "purple"
  | "yellow"
  | "blue";

export interface StickerProps extends HTMLAttributes<HTMLSpanElement> {
  color?: StickerColor;
  rotate?: number;
  children?: ReactNode;
}

export function Sticker({
  color = "green",
  rotate = -6,
  className,
  style,
  children,
  ...rest
}: StickerProps) {
  return (
    <span
      {...rest}
      className={clsx("sticker", `sticker--${color}`, className)}
      style={{ transform: `rotate(${rotate}deg)`, ...style }}
    >
      {children}
    </span>
  );
}
